import { render, staticRenderFns } from "./VLetterIcon.vue?vue&type=template&id=79157520&scoped=true&"
import script from "./VLetterIcon.vue?vue&type=script&lang=ts&"
export * from "./VLetterIcon.vue?vue&type=script&lang=ts&"
import style0 from "./VLetterIcon.vue?vue&type=style&index=0&id=79157520&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79157520",
  null
  
)

export default component.exports